const toggleDescription = document.querySelector(
  '.category__toggle-description'
)
const categoryActiveClass = 'category__toggle-description--active'

if (toggleDescription) {
  toggleDescription.addEventListener('click', () => {
    const description = document.querySelector('.category__description--more')

    if (toggleDescription.classList.contains(categoryActiveClass)) {
      toggleDescription.classList.remove(categoryActiveClass)
      description.style.maxHeight = null
    } else {
      toggleDescription.classList.add(categoryActiveClass)

      description.style.maxHeight = null
      const targetHeight = description.scrollHeight + 'px'

      setTimeout(() => {
        description.style.maxHeight = targetHeight
      }, 0)
    }
  })
}
